import React from "react";

function calculatePHS({
  Ta,
  RH,
  Tg,
  D,
  Va,
  M,
  Weight,
  Height,
  Accl,
  Drink,
  Duration,
  Work,
  Icl,
  imst,
  Ap,
  Fr,
  Ecl,
  posture,
}) {
    const math = Math; // Utilisation de Math JS

    // Constantes de moyennage exponentiel
    const ConstTeq = math.exp(-1 / 10); // Constante pour la température corporelle centrale
    const ConstTsk = math.exp(-1 / 3); // Constante pour la température cutanée
    const ConstSW = math.exp(-1 / 10); // Constante pour le débit sudoral

    // Paramètres dérivés
    const Adu = 0.202 * Math.pow(Weight, 0.425) * Math.pow(Height, 0.725); // Surface du corps en m²
    const aux = (3490 * Weight) / Adu; // Chaleur pour 1°C d'élévation par m²
    const SWmax = Accl === 1 ? 500 : 400; // Capacité évaporatoire maximale
    const wmax = Accl === 1 ? 1 : 0.85; // Mouillure maximale
    const Dmax = (Drink === 1 ? 0.05 : 0.03) * Weight * 1000; // Perte hydrique max en g
    const Dmax_50 = 0.075 * Weight * 1000; // Perte hydrique max pour 50% des sujets

    // Calculs dérivés
    const Tr =
    Math.pow(
        Math.pow(Tg + 273, 4) +
        (1.1579e8 / 0.95 / Math.pow(D / 100, 0.4)) * Math.pow(Va, 0.6) * (Tg - Ta),
        0.25
    ) - 273;

    const Pa =
    0.6105 *
    Math.exp((17.27 * Ta) / (Ta + 237.3)) *
    (RH / 100); // Pression partielle de vapeur

    const Met = M / Adu; // Métabolisme énergétique par m²

    let Ardu;
    if (posture === 1) {
    Ardu = 0.77;
    } else if (posture === 2) {
    Ardu = 0.7;
    } else if (posture === 3) {
    Ardu = 0.67;
    }

    // Influence du vêtement sur les coefficients d’échange thermique
    const Iclst = Icl * 0.155; // Isolement thermique statique du vêtement
    const fcl = 1 + 0.28 * Icl; // Facteur de surface du vêtement
    const Iast = 0.111; // Isolement thermique statique de la couche limite dans un air calme
    const Itotst = Iclst + Iast / fcl; // Isolement thermique statique total





    // Déplacements
    let defspeed = 0; // = 1 si vitesse de marche saisie, sinon = 0
    let Walksp = 0; // Vitesse de marche, m/s
    let defdir = 0; // = 1 si sens de marche saisi, sinon = 0
    let THETA = 0; // Angle entre le sens de marche et la direction du vent, degrés

    // Calcul des vitesses relatives dues à la vitesse de l'air et aux mouvements
    let Var;

    if (defspeed > 0) {
    if (defdir === 1) {
    // Marche unidirectionnelle
    Var = Math.abs(Va - Walksp * Math.cos((Math.PI * THETA) / 180));
    } else {
    // Marche omnidirectionnelle
    Var = Va < Walksp ? Walksp : Va;
    }
    } else {
    // Si la vitesse de marche n'est pas définie, calcul par défaut
    Walksp = 0.0052 * (Met - 58);
    if (Walksp > 0.7) {
    Walksp = 0.7;
    }
    Var = Va;
    }

    // Vitesses relatives dues à la vitesse de l’air et aux mouvements
    // Isolement thermique dynamique du vêtement
    if (Var > 3) {
    Var = 3;
    }

    Walksp = Met > 58 ? 0.0052 * (Met - 58) : 0;
    if (Walksp > 1.5) {
    Walksp = 1.5;
    }







    // Correction d'isolement thermique
    const CORcl = Math.min(
    1,
    1.044 * Math.exp((0.066 * Var - 0.398) * Var + (0.094 * Walksp - 0.378) * Walksp)
    );

    const CORia = Math.min(
    1,
    Math.exp((0.047 * Var - 0.472) * Var + (0.117 * Walksp - 0.342) * Walksp)
    );

    let CORtot = CORcl;
    if (Icl <= 0.6) {
    CORtot = ((0.6 - Icl) * CORia + Icl * CORcl) / 0.6;
    }

    const Itotdyn = Itotst * CORtot; // Isolement thermique dynamique total
    const Iadyn = CORia * Iast;
    const imdyn = Math.min(0.9, imst * ((2.6 * CORtot - 6.5) * CORtot + 4.9)); // Résistance évaporatoire dynamique
    const Rtdyn = Itotdyn / imdyn / 16.7; // Résistance évaporatoire dynamique





    // Initialisation des variables
    let Tre = 36.8;
    let Tcr = 36.8;
    let Tsk = 34.1;
    let Tcreq = 36.8;
    let TskTcrwg = 0.3;

    let SWp = 0;
    let SWtot = 0;
    let Dlimtcr = 999;
    let Dlimloss_95 = 999;
    let Dlimloss_50 = 999;


    const PHS_data = [];



    for (let time = 1; time <= Duration; time++) {
        // Initialisation minute par minute !!! Le pas est en MINUTE !!!
        let Tre0 = Tre;
        let Tcr0 = Tcr;
        let Tsk0 = Tsk;
        let Tcreq0 = Tcreq;
        let TskTcrwg0 = TskTcrwg;

        // Température corporelle centrale associée au métabolisme énergétique
        // Équilibre de la température corporelle centrale associée au métabolisme énergétique
        let Tcreqm = 0.0036 * Met + 36.6;

        // Température corporelle centrale à cette minute, par moyennage exponentiel
        Tcreq = Tcreq0 * ConstTeq + Tcreqm * (1 - ConstTeq);

        // Stockage de chaleur associé à cette élévation de la température corporelle centrale durant la dernière minute
        let dStoreq = (aux / 60) * (Tcreq - Tcreq0) * (1 - TskTcrwg0);

        // PRÉVISION DE LA TEMPÉRATURE CUTANÉE
        // Température cutanée en équilibre
        let Tskeqcl = (
        12.165 + 0.02017 * Ta + 0.04361 * Tr + 0.19354 * Pa // Sujet vêtu
        - 0.25315 * Va + 0.005346 * Met + 0.51274 * Tre
        );
        let Tskeqnu = (
        7.191 + 0.064 * Ta + 0.061 * Tr + 0.198 * Pa // Sujet nu
        - 0.348 * Va + 0.616 * Tre
        );

        // Valeur à cette minute, en fonction de l’isolement du vêtement
        let Tskeq;
        if (Icl >= 0.6) {
            Tskeq = Tskeqcl;
        } else if (Icl <= 0.2) {
            Tskeq = Tskeqnu;
        } else {
            Tskeq = Tskeqnu + 2.5 * (Tskeqcl - Tskeqnu) * (Icl - 0.2);
        }

        // Température cutanée à cette minute, par moyennage exponentiel
        Tsk = Tsk0 * ConstTsk + Tskeq * (1 - ConstTsk);
        if (time === 1) {
            Tsk = Tskeq;
        }

        // Pression saturée de vapeur d’eau au niveau de la peau
        let Psk = 0.6105 * Math.exp((17.27 * Tsk) / (Tsk + 237.3));

        // Température moyenne du vêtement (Tcl)
        let Z = 3.5 + 5.2 * Var;
        if (Var > 1) {
            Z = 8.7 * Math.pow(Var, 0.6);
        }

        let auxR = 5.67e-8 * Ardu; // Constante pour les échanges radiatifs
        let Eclr = (1 - Ap) * Ecl + Ap * (1 - Fr); // Échange thermique radiatif pondéré

        let Tcl = Tr + 0.1;

        // let iteration = 0;
        // while (iteration < 100) {
        let Hc;
        let Hr;
        let Tcl1;
        while (true) {
            // Coefficient de convection
            Hc = 2.38 * Math.pow(Math.abs(Tcl - Ta), 0.25);
            if (Z > Hc) {
                Hc = Z;
            }

            // Coefficient d'échange radiatif
            Hr = (Eclr * auxR * (Math.pow(Tcl + 273, 4) - Math.pow(Tr + 273, 4))) / (Tcl - Tr);

            // Nouvelle estimation de Tcl
            Tcl1 = (
                (fcl * (Hc * Ta + Hr * Tr) + Tsk / Itotdyn) /
                (fcl * (Hc + Hr) + 1 / Itotdyn)
            );

            // Vérification de la convergence
            if (Math.abs(Tcl - Tcl1) <= 0.001) {
                break;
            }

            // Mise à jour pour l'itération suivante
            Tcl = (Tcl + Tcl1) / 2;
        }


        // ÉCHANGES DE CHALEUR
        let Texp = 28.56 + 0.115 * Ta + 0.641 * Pa; // Température de l’air expiré
        let Cres = 0.001516 * Met * (Texp - Ta); // Échanges de chaleur par convection respiratoire
        let Eres = 0.00127 * Met * (59.34 + 0.53 * Ta - 11.63 * Pa); // Par évaporation respiratoire
        let Conv = fcl * Hc * (Tcl - Ta); // Échanges de chaleur par convection
        let Rad = fcl * Hr * (Tcl - Tr); // Échanges de chaleur par rayonnement
        let Emax = (Psk - Pa) / Rtdyn; // Flux de chaleur d'évaporation maximal
        let Ereq = Met - Cres - Eres - Conv - Rad; // Flux de chaleur d'évaporation requis

        // INTERPRÉTATION
        let wreq = Ereq / Emax; // Mouillure requise

        // Si aucune évaporation requise : pas de débit sudoral
        let SWreq;
        if (Ereq <= 0) {
            Ereq = 0;
            SWreq = 0;
        } else if (Emax <= 0) {
            // Si l’évaporation n’est pas possible, le débit sudoral est maximal
            Emax = 0;
            SWreq = Infinity;
        } else {
            // Si la mouillure requise est supérieure à 1.7 : le débit sudoral est maximal
            if (wreq > 1.7) {
                wreq = 1.7;
            }
            let Eveff = 1 - (wreq ** 2) / 2;
            if (wreq > 1) {
                Eveff = ((2 - wreq) ** 2) / 2; // Rendement évaporatoire requis
            }

            SWreq = Ereq / Eveff; // Débit sudoral requis
            if (SWreq > SWmax) {
                SWreq = SWmax; // Limité à la capacité évaporatoire maximale
            }
        }

        // Débit sudoral prévisible par moyennage exponentiel
        SWp = SWp * ConstSW + SWreq * (1 - ConstSW);

        // Flux de chaleur par évaporation prévisible
        let Ep;
        if (SWp > 0) {
            let k = Emax / SWp;
            let wp = 1;
            if (k >= 0.5) {
                wp = -k + Math.sqrt(k ** 2 + 2);
            }
            wp = Math.min(wp, wmax);
            Ep = wp * Emax;
        } else {
            Ep = 0;
        }

        // Stockage de chaleur dynamique
        let dStorage = Ereq - Ep + dStoreq;

        // PRÉDICTION DE LA TEMPÉRATURE CORPORELLE CENTRALE
        let Tcr1 = Tcr0;

        // Boucle pour calculer la température corporelle centrale
        while (true) {
            // Pondération température cutanée - température corporelle centrale
            TskTcrwg = 0.3 - 0.09 * (Tcr1 - 36.8);
            TskTcrwg = Math.max(0.1, Math.min(0.3, TskTcrwg));

            Tcr =
                (dStorage / (aux / 60)) +
                (Tsk0 * TskTcrwg0 / 2) -
                (Tsk * TskTcrwg / 2);

            Tcr = (Tcr + Tcr0 * (1 - TskTcrwg0 / 2)) / (1 - TskTcrwg / 2);

            if (Math.abs(Tcr - Tcr1) <= 0.001) {
                break;
            }

            Tcr1 = (Tcr1 + Tcr) / 2;
        }

        // PRÉDICTION DE LA TEMPÉRATURE RECTALE
        Tre = Tre0 + (2 * Tcr - 1.962 * Tre0 - 1.31) / 9;

        // DÉBIT DE PERTE HYDRIQUE TOTALE APRÈS LA MINUTE (en W/m²)
        SWtot += SWp + Eres;
        let SWtotg = (SWtot * 2.67 * Adu) / 1.8 / 60; // Perte hydrique totale en grammes
        let SWpgh = (SWp * 2.67 * Adu) / 1.8 / 60;

        // CALCUL DE LA DURÉE LIMITE D’EXPOSITION (DLE) EN MINUTES
        // DLE vis-à-vis de la perte hydrique, 95 % des travailleurs
        if (Dlimloss_95 === 999 && SWtotg > Dmax) {
            Dlimloss_95 = time;
            console.log(`Durée limite due à la perte hydrique : ${Dlimloss_95} min, pour 95% de la population`);
            console.log(`Perte hydrique : ${SWtotg} g`);
        }

        // DLE vis-à-vis de la perte hydrique, sujet moyen
        if (Dlimloss_50 === 999 && SWtotg > Dmax_50) {
            Dlimloss_50 = time;
            console.log(`Durée limite due à la perte hydrique : ${Dlimloss_50} min, pour un sujet moyen`);
            console.log(`Perte hydrique : ${SWtotg} g`);
        }

        // DLE vis-à-vis du stockage de chaleur
        if (Dlimtcr === 999 && Tre >= 38) {
            Dlimtcr = time;
            console.log(`Durée limite due à la température corporelle : ${Dlimtcr} min`);
        }

        if (Dlimtcr === 999 && Tre >= 39.5) {
            Dlimtcr = time;
            console.log(`Durée limite due à Tre >= 39.5 : ${Dlimtcr} min`);
        }

        // Enregistrement des données pour PHS
        PHS_data.push({
            time,
            Tcr,
            Tre,
            Tsk,
            dStorage,
            TskTcrwg,
            SWp,
            SWtot,
            SWtotg,
            Emax,
            Dmax,
            Dmax_50
        });

    }

    // Retour des résultats
    return {
        PHS_data,
        Dlimloss_50,
        Dlimloss_95,
        Dlimtcr
    };
    
}

export default calculatePHS;







